import { checkAuth, CheckAuthOptions, useAuth } from '../utils/auth-utils';

interface AuthProtectedProps extends Omit<CheckAuthOptions, 'auth'> {
  children: JSX.Element | null;
}

export function AuthProtected({ type, children }: AuthProtectedProps) {
  const auth = useAuth();
  const isAuth = checkAuth({ type, auth });

  if (isAuth) {
    return children;
  }

  return null;
}
